export const content = `You can add an emergency contact from your account settings or from the **Action Items** in your dashboard, if you haven’t added one already.

If you don’t already have an emergency contact, look for an action item that says “Add an emergency contact for your Care Team” and select **Add**.

![](https://lh7-rt.googleusercontent.com/docsz/AD_4nXcVqexcjao0FuPfyNyPrzcP1KquSzRyrQks2JfO9noGVUnMVLV3YoIznY66Gu5UcnsECDf6nNgq0t0QHyi9gMgVLdQWUiyInLAy-WtgxqJ6Tzk0KTcRrFvSZi7aqzFjsYus4czS?key=X_qAGGjtHqUyfCz1NzAHxOO7)

To update your emergency contact, just follow the steps below.

## On mobile

1. When you login to your account, use the ![](https://lh7-rt.googleusercontent.com/docsz/AD_4nXeXIJwP04KvM06u6WIx8nuaAoPCWQryeyiMM-hYrdALADSohtrLj-88TxvoJlIbRn-v70pQgmMDfThQOPkDhjpr1o65hbeCDqBdZ7ENVcmsAbBJ-fVkdg5ZuMhHnMtnn2AX5ehMmQ?key=X_qAGGjtHqUyfCz1NzAHxOO7) icon to open your navigation menu.
2. Select [**Account Settings**](/settings).
3. Scroll down to **Contact Information**.
4. Where you see Emergency Contact, select the > icon.
5. Add your contact’s full name, relationship to you, and a phone number where they can reliably be reached.
6. Select **Save**.

## On desktop

1. When you login to your account, go to [**Account Settings**](/settings) from your sidebar navigation.
2. Scroll down to **Contact Information**.
3. Where you see Emergency Contact, select **Edit** or **Add**, if you don’t already have one.
4. Add your contact’s full name, relationship to you, and a phone number where they can reliably be reached.
5. Select **Save**.

## Who should I put as an emergency contact?

Your emergency contact should be someone you can trust when it comes to your mental health. When we discuss trust for your contact, we mean someone that you know cares about your safety and is willing to support you. It should also be someone that you feel confident we could reach in case of an emergency.
`;
